const BASE = {
	colors: {
		text: '#1e293b',
		disabled: '#919191',
		muted: '#64748b',
		background: '#ffffff',
		primary: '#2A4E6C',
		primaryLight: '#89B0D1',
		secondary: '#2A4E6C',
		tertiary: '#005EAD',
		success: '#58C322',
		warning: '#FEAB1B',
		yellow: '#FFE24D',
		error: '#D41111',
		itemBackground: '#89B0D1',
		itemColor: '#fff',
		tabBackground: '#b8cbf2',
		separator: '#f5f0f0',
		activity: '#005EAD',
		todo: '#eb1d24',
		canceled: '#1e293b',
		updated: '#005EAD',
		done: '#43A047',
		bright: '#ffffff',
		container: '#e3e3e3',
		grey: '#D9D9D9',
		textBlack: '#000000',
		activityColor: '#0BCBCB',
		unavailabilityColor: '#f87575',
		calendar: '#D9D9D9',
		separatorTable: '#CECECE',
	},
	breakpoints: {
		xs: '400px',
		sm: '640px',
		md: '768px',
		lg: '1219.99px',
		xl: '1280px',
	},
	fonts: {
		body: '"Circular", "Helvetica", "Arial", sans-serif',
		logo: '"Euclid Flex", "Helvetica", "Arial", sans-serif',
		heading: 'inherit',
		monospace: 'Menlo, monospace',
	},
	fontWeights: {
		body: 400,
		heading: 700,
		bold: 700,
	},
	lineHeights: {
		body: 1.5,
		heading: 1.125,
	},
};

// eslint-disable-next-line import/prefer-default-export
export const THEME = {
	light: {
		...BASE,
		mode: 'light',
	},
	dark: {
		...BASE,
		mode: 'dark',
		colors: {
			text: '#fcfcfc',
			disabled: '#919191',
			muted: '#ffffff',
			background: '#1b2535',
			navigation: '#1e293b',
			primary: '#6c29f5',
			primaryLight: '#9c6df5',
			secondary: '#f56c29',
			tertiary: '#f5a629',
			card: '#1e293b',
			separator: '#1e293b',
			checkbox: '#ffffff',
			todo: '#3F3351',
			canceled: '#191A19',
			done: '#43A047',
			bright: '#0a0e14',
			error: '#EE2B3B',
			success: '#81E052',
			warning: '#FBC850',
			updated: '#005EAD',
			container: '#0a0e14',
			ok: '#92be1f',
			da: '#8d46de',
			hs: '#ff6700',
			x: '#d21c00',
			be: '#a32cc4',
		},
	},
};
